import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Drawer, Icon, IconButton } from '@material-ui/core'
import BackButton from 'components/ui/backButton/BackButton'
import React, { FC, useCallback, useState } from 'react'
import { Header } from '../../../../components/header/Header'
import { useAuth } from '../../../../context/auth/AuthContext'
import { useUi } from '../../../../context/ui/UIContext'
import Menu from '../../privateLayout/menu/Menu'
import './PrivateHeader.css'
import UserApi from 'services/Api/user/UserApi'
import LanguageSelector from '../../../../components/languageSelector/LanguageSelector'
import { useI18n } from 'utils/i18n/hooks/useI18n'

interface PrivateHeaderProps {
    // onClickMenu?: () => void
    menuDisabled?: boolean;
    confirmBack?: boolean;
    onClickBack?: () => void;
    title?: string
}
export const PrivateHeader: FC<PrivateHeaderProps> = ({ menuDisabled, onClickBack, confirmBack, title }) => {
    const { logout, isAuth, openModalLogin } = useAuth();
    const { isIframe } = useUi();
    const [openMenu, setopenMenu] = useState(false);
    const { t } = useI18n();

    const [dialogLogoutOpen, setdialogLogoutOpen] = useState(false);
    const [dialogSairOpen, setdialogSairOpen] = useState(false);
    const [dialogDeleteAccountOpen, setDialogDeleteAccountOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);

    const userApi = UserApi();
    
    const onClickLogout = () => {
        logout();
        setdialogLogoutOpen(false);
    }

    const onClickConfirmBack = useCallback(() => {
        if (isIframe) {
            window.parent.postMessage({ command: "CLOSE" }, "*")
        } else {
            onClickBack && onClickBack();
        }
    }, [isIframe, onClickBack])

    const onClickBackHandle = useCallback(
        () => {
            if (confirmBack) {
                setdialogSairOpen(true);
            } else {
                onClickConfirmBack();
            }
        },
        [confirmBack, onClickConfirmBack],
    )


    const onClickLogin = useCallback(() => {
        openModalLogin();
    }, [openModalLogin])

    const onClickMenu = useCallback(() => {
        setopenMenu(prev => !prev);
    }, [])


    const onClickDeleteAccount = useCallback(() => {
        setDialogDeleteAccountOpen(true);
        setopenMenu(false);
    }, [])

    const handleDeleteAccount = async () => {
        setIsDeleting(true);
        await userApi.removeAccount();
        logout();
        setDialogDeleteAccountOpen(false);
        setIsDeleting(false);
    }

    return (
        <div id={"privateHeader"}>
            <Header
                start={
                    <div className="iconButtonContainer">
                        {
                            (isIframe || onClickBack) &&
                            <BackButton className={'backButton'} onClick={onClickBackHandle} />
                        }
                    </div>
                }
                center={
                    <h2>{title}</h2>
                }
                end={
                    <>
                        <div className="iconButtonContainer">
                            <LanguageSelector />
                        </div>
                        {
                            menuDisabled ?
                                <div className="iconButtonContainer">
                                    {/* <IconButton><Icon className="icon">account_circle</Icon></IconButton> */}
                                    <IconButton onClick={() => { setdialogLogoutOpen(true) }}><Icon className="icon">logout</Icon></IconButton>
                                </div>
                                :
                                <div className="iconButtonContainer">
                                    <IconButton onClick={onClickMenu}><Icon className="icon">menu</Icon></IconButton>
                                </div>
                        }
                    </>
                }
            />
            <Dialog open={dialogLogoutOpen} onClose={() => { setdialogLogoutOpen(false) }} >
                <DialogTitle>{t("dialogs.logout.title")}</DialogTitle>
                <DialogContent>
                    {t("dialogs.logout.message")}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setdialogLogoutOpen(false) }} variant="outlined" >{t("dialogs.logout.cancel")}</Button>
                    <Button onClick={onClickLogout} variant="outlined" >{t("dialogs.logout.confirm")}</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={dialogSairOpen} onClose={() => { setdialogSairOpen(false) }} >
                <DialogTitle>{t("dialogs.orderInProgress.title")}</DialogTitle>
                <DialogContent>
                    {t("dialogs.orderInProgress.message")}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setdialogSairOpen(false) }} variant="outlined" >{t("dialogs.orderInProgress.cancel")}</Button>
                    <Button onClick={onClickConfirmBack} variant="outlined" >{t("dialogs.orderInProgress.confirm")}</Button>
                </DialogActions>
            </Dialog>

            <Dialog open={dialogDeleteAccountOpen} onClose={() => { setDialogDeleteAccountOpen(false) }} >
                <DialogTitle>{t("dialogs.deleteAccount.title")}</DialogTitle>
                <DialogContent>
                    {t("dialogs.deleteAccount.message")}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setDialogDeleteAccountOpen(false) }} variant="outlined" disabled={isDeleting}>{t("dialogs.deleteAccount.cancel")}</Button>
                    <Button 
                        onClick={handleDeleteAccount} 
                        variant="outlined" 
                        color="secondary" 
                        disabled={isDeleting}
                    >
                        {isDeleting ? t("dialogs.deleteAccount.deleting") : t("dialogs.deleteAccount.confirm")}
                    </Button>
                </DialogActions>
            </Dialog>

            <Drawer anchor="right" open={openMenu} style={{ minWidth: 250 }} onClose={() => setopenMenu(false)}>
                <Menu
                    onClickOut={isAuth ? () => setdialogLogoutOpen(true) : undefined}
                    onClickLogin={!isAuth ? () => onClickLogin() : undefined}
                    onClickDeleteAccount={isAuth ? onClickDeleteAccount : undefined} />
            </Drawer>
        </div>
    )
}
